import { render, staticRenderFns } from "./leverDetail.vue?vue&type=template&id=2f80f6fe&scoped=true&"
import script from "./leverDetail.vue?vue&type=script&lang=js&"
export * from "./leverDetail.vue?vue&type=script&lang=js&"
import style0 from "./leverDetail.vue?vue&type=style&index=0&id=2f80f6fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f80f6fe",
  null
  
)

export default component.exports